"use strict";
var merge_1 = require('../operator/merge');
exports.merge = merge_1.mergeStatic;
//# sourceMappingURL=merge.js.map


//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/rxjs/observable/merge.js
// module id = ../../../../rxjs/observable/merge.js
// module chunks = 4